export default __webpack_public_path__ + "static/media/cleanproCope.23ba4b3f.jpg";